import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import DataTableModule from '@/__core/layout/module/DataTableModule';

interface FinancialOverviewRow3Props {
  row3Data: Record<string, string | number>[];
  row3Columns: any[];
  row3GroupHeaderRows: Array<Array<{ label: string; colSpan: number; align?: 'left' | 'center' | 'right' }>>;
}

export default function FinancialOverviewRow3({
  row3Data,
  row3Columns,
  row3GroupHeaderRows,
}: FinancialOverviewRow3Props) {
  return (
    <Grid size={{ xs: 12 }} sx={{ minWidth: 0 }}>
      <Typography variant='h6' gutterBottom>
        Tổng hợp thu chi - Lợi nhuận thực tế
      </Typography>
      <Box sx={{ mt: 1, width: '100%', maxWidth: '100%', overflow: 'visible' }}>
        <DataTableModule
          data={row3Data}
          tableLayout='fixed'
          columns={row3Columns}
          groupHeaderRows={row3GroupHeaderRows}
          onRowSelect={() => undefined}
          onSelectAll={() => undefined}
          getRowId={(row) => String((row as any).id || '')}
          isRowSelected={() => false}
          areAllRowsSelected={false}
          areSomeRowsSelected={false}
          showCheckbox={false}
          reserveLeftFilterSpace={false}
        />
      </Box>
    </Grid>
  );
}
